// import React, { useState, useRef, useEffect } from "react";
// import styled from "styled-components";
// import theme from "../../../assets/theme";
// import { PrimaryCTAButton } from "../../common/Buttons";
// import ChatModal from "./ChatModal";
// import COLORS from "../../../assets/Colors";
// import { useSnackbar } from "notistack";
// import { getErrorMessage } from "../../../helpers/functions";
// import "./Timeline.css";
// import EventService from "../../../services/EventService";
// import useViewer from "../../../hooks/useViewer";
// import LiveTickers from "../Liveresources/Tickers";
// import Feedback from "../Liveresources/Feedback";
// import VideoBox from "../../common/VideoBox";
// import MenuBurger from "../../common/ActionBar/MenuBurger";
// import { navigate, useLocation } from "@reach/router";
// import Polling from "../../common/Polling";
// import AgendaTab from "../MenuBar/Agenda";
// import SpeakersTab from "../MenuBar/Speakers";
// import ResourcesTab from "../MenuBar/Resources";
// import VideosTab from "../MenuBar/Videos";
// import HostService from "../../../services/HostService";
// import useLoader from "../../../hooks/useLoader";
// import PollBarChart from "../MenuBar/PollBarChart";
// import GeneralGuidelinesTab from "../MenuBar/GeneralGuidelines";
// import { DrawerContainer } from "../Register";
// import VideoPlayer from "../../common/Video";
// import CustomAudioPlayer from "../AudioPlayer/CustomAudioPlayer";
// import CustomAudioPlayerImage from "../AudioPlayer/CustomAudioPlayerImage";
// import FAQs from "../MenuBar/Faqs";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
// } from "@material-ui/core";
// import GuidelinesDialog from "./GuidelinesDialog";

// import CloseIcon from "@material-ui/icons/Close";
// const JoinEvent = () => {
//   const buttonRef = useRef(null);
//   const { enqueueSnackbar } = useSnackbar();
//   const { userObject, setGlobalState } = useViewer();
//   const [modal, setModal] = useState({ state: false });
//   const [userData, setUserData] = useState();
//   const location = useLocation();
//   const [pollModal, setPollModal] = useState({ state: false });
//   const { setLoader } = useLoader();
//   const [fields, setFields] = useState({});
//   const [initialState, setInitialState] = useState();

//   const [pollResult, setPollResult] = useState([]);
//   const [guidelinesOpen, setGuidelinesOpen] = useState(false);
//   useEffect(() => {
//     async function getEventInfo() {
//       try {
//         setLoader({ state: true, message: "Fetching live..." });
//         const response = await EventService.eventInfoEventViewerLive(
//           userObject?.eventId,
//           "live",
//         );
//         setUserData(response);
//         setGlobalState(response);
//         setFields(response?.feedback?.feedbackForm);
//         if (response?.feedback?.feedbackForm !== null) {
//           if (Object.keys(response?.feedback?.feedbackForm).length !== 0) {
//             setInitialState(
//               Object.keys(response?.feedback?.feedbackForm).reduce(
//                 (acc, key) => {
//                   const firstFieldType =
//                     response?.feedback?.feedbackForm[key][0]?.type;
//                   acc[key] =
//                     firstFieldType === "checkbox"
//                       ? []
//                       : firstFieldType === "radio" ||
//                           firstFieldType === "select"
//                         ? ""
//                         : "";
//                   return acc;
//                 },
//                 {},
//               ),
//             );
//           }
//         }
//       } catch (err) {
//         const message = getErrorMessage(err);
//         enqueueSnackbar(message, {
//           variant: "error",
//         });
//         if (err.errorCode === "ER-UNAUTHORISED-USER") {
//           navigate(location.pathname);
//         }
//       } finally {
//         setLoader({ state: false });
//       }
//     }
//     if (userObject?.eventId) {
//       getEventInfo();
//     } // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userObject?.eventId]);

//   useEffect(() => {
//     if (userObject?.eventId) {
//       const interval = setInterval(() => {
//         (async function getEventInfo() {
//           try {
//             const response = await EventService.eventInfoEventViewerLive(
//               userObject?.eventId,
//               "live",
//             );
//             setUserData(response);
//             setGlobalState(response);
//             setFields(response?.feedback?.feedbackForm);
//             if (
//               response?.polling?.pollQuestions.filter((arr) => arr.pollResult)
//                 .length
//             ) {
//               const res = await HostService.getPollingResults(
//                 userObject?.eventId,
//               );
//               setPollResult(res?.IndividualPollResponses);
//             }
//             if (response) {
//               if (response?.feedback?.feedbackForm !== null) {
//                 if (
//                   Object.keys(response?.feedback?.feedbackForm).length !== 0
//                 ) {
//                   setInitialState(
//                     Object.keys(response?.feedback?.feedbackForm).reduce(
//                       (acc, key) => {
//                         const firstFieldType =
//                           response?.feedback?.feedbackForm[key][0]?.type;
//                         acc[key] =
//                           firstFieldType === "checkbox"
//                             ? []
//                             : firstFieldType === "radio" ||
//                                 firstFieldType === "select"
//                               ? ""
//                               : "";
//                         return acc;
//                       },
//                       {},
//                     ),
//                   );
//                 }
//               }
//               if (response?.livepage?.livePageSettings?.livePoll) {
//                 if (
//                   response?.polling?.pollQuestions?.filter(
//                     (item) => item?.accept === "pollsAreLive",
//                   ).length &&
//                   response?.polling?.pollQuestions
//                     ?.filter((item) => item?.accept === "pollsAreLive")
//                     .some(
//                       (arr) =>
//                         !localStorage
//                           .getItem("pollArray")
//                           .includes(arr.question),
//                     )
//                 ) {
//                   setPollModal({
//                     state: true,
//                     eventId: userObject?.eventId,
//                     viewerId: userObject?.id,
//                     userData: response?.polling?.pollQuestions
//                       ?.filter((item) => item?.accept === "pollsAreLive")
//                       .filter(
//                         (arr) =>
//                           !localStorage
//                             .getItem("pollArray")
//                             .includes(arr.question),
//                       ),
//                   });
//                 } else {
//                   setPollModal({
//                     state: false,
//                   });
//                 }
//               }
//             }
//           } catch (err) {
//             if (err.errorCode === "ER-UNAUTHORISED-USER") {
//               navigate(location.pathname);
//             }
//           }
//         })();
//       }, 5000);
//       return () => clearInterval(interval);
//     }
//   }, [userObject?.eventId]); // eslint-disable-line react-hooks/exhaustive-deps

//   const actions = [
//     {
//       text: "Home",
//       props: {
//         onClick: () => {
//           navigate(`/live#home`);
//         },
//       },
//     },
//     {
//       text: "Agenda",
//       props: {
//         onClick: () => {
//           navigate("#agenda");
//         },
//       },
//       hidden:
//         userData?.event?.speakerSection?.speakersRequired &&
//         userData?.event?.eventSettings?.userViewInsidePage
//           ? false
//           : true,
//     },
//     {
//       text: "Speakers",
//       props: {
//         onClick: () => {
//           navigate("#speakers");
//         },
//       },
//       hidden:
//         userData?.event?.speakerSection?.speakersRequired &&
//         userData?.event?.eventSettings?.userViewInsidePage
//           ? false
//           : true,
//     },
//     {
//       text: "Resources",
//       props: {
//         onClick: () => {
//           navigate("#resources");
//         },
//       },
//       hidden:
//         userData?.event?.resourceSection?.resourcesRequired &&
//         userData?.event?.eventSettings?.userViewInsidePage
//           ? false
//           : true,
//     },
//     {
//       text: "Videos",
//       props: {
//         onClick: () => {
//           navigate("#videos");
//         },
//       },
//       hidden:
//         userData?.event?.resourceSection?.resourcesRequired &&
//         userData?.event?.eventSettings?.userViewInsidePage
//           ? false
//           : true,
//     },
//     {
//       text: "Polling",
//       props: {
//         onClick: () => {
//           navigate("#polling");
//         },
//       },
//       hidden: userData?.livepage?.livePageSettings?.livePoll ? false : true,
//     },
//     {
//       text: userData?.livepage?.livePageSettings?.generalGuidelinesLabel
//         ? userData?.livepage?.livePageSettings?.generalGuidelinesLabel
//         : "General Guidelines Tab",
//       props: {
//         onClick: () => {
//           navigate("#general-guidelines-tab");
//         },
//       },
//       hidden: userData?.livepage?.livePageSettings?.generalGuidelines
//         ? false
//         : true,
//     },
//     {
//       text: "FAQs",
//       props: {
//         onClick: () => {
//           navigate("#faqs");
//         },
//       },
//     },
//     {
//       text: "Help",
//       props: {
//         onClick: () => {
//           navigate("#help");
//         },
//       },
//     },
//     {
//       text: "Feedback",
//       props: {
//         onClick: () => {
//           navigate("#feedback");
//         },
//       },
//       hidden:
//         userData?.feedback?.feedbackForm &&
//         Object.keys(userData.feedback.feedbackForm).length !== 0
//           ? false
//           : true,
//     },
//   ];

//   const { resourceSection, resourceSetting, speakerSection, speakerSettings } =
//     userData || {};
//   const { resourcesRequired, resourcesVisibility } = resourceSection || {};
//   const { speakersRequired, speakersVisibility } = speakerSection || {};

//   const { galleryView } = userData?.livepage || {};
//   // Define condition in a variable
//   const shouldRenderResources =
//     resourcesRequired &&
//     (resourcesVisibility === "afterLogin" ||
//       resourcesVisibility === "bothBeforeAfter");

//   // Define condition in a variable
//   const shouldRenderSpeakers =
//     speakersRequired &&
//     (speakersVisibility === "afterLogin" ||
//       speakersVisibility === "bothBeforeAfter");

//   const shouldRenderAgmHeader =
//     userData?.general?.eventTemplate === "AGM" && galleryView?.showHeader
//       ? true
//       : userData?.general?.eventTemplate !== "AGM"
//         ? true
//         : userData?.general?.eventTemplate === "AGM" && !galleryView?.showHeader
//           ? false
//           : true;

//   const renderSecondaryContent = () => {
//     const media = userData?.theme?.themeGeneral?.secondaryContentMedia;

//     if (!media) return null;

//     const extension = media.split(".").pop().toLowerCase();

//     if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(extension)) {
//       return (
//         <img
//           src={media}
//           alt="Secondary Content"
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "contain",
//           }}
//         />
//       );
//     }

//     if (extension === "pdf") {
//       return (
//         <iframe
//           src={media}
//           title="Secondary Content"
//           width="100%"
//           height="100%"
//           style={{ border: "none" }}
//         />
//       );
//     }

//     if (["mp4", "webm", "ogg"].includes(extension)) {
//       return (
//         <video
//           src={media}
//           controls
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//         />
//       );
//     }

//     return null;
//   };

//   const liveStream = userData?.livepage?.liveStreamSettings?.find(
//     (item) => item.label === "Live Stream",
//   );
//   const secondaryContentNode = renderSecondaryContent();
//   const hasLiveVideo = !!liveStream?.liveStreamPlayerUrl;
//   const hasSecondaryContent = !!secondaryContentNode;
//   const isSoloStage =
//     (hasLiveVideo && !hasSecondaryContent) ||
//     (hasSecondaryContent && !hasLiveVideo);

//   const headerHeight = Math.max(
//     Number(userData?.theme?.themeHeader?.logoHeight) || 120,
//     Number(userData?.theme?.themeHeader?.secondaryLogoHeight) || 120,
//     150,
//   );

//   const tickerPosition = userData?.tickers?.tickerSettings?.tickerPosition;

//   const showTicker =
//     userData?.livepage?.livePageSettings?.liveTickers &&
//     userData?.tickers?.tickerSettings?.tickerVisibility === "tickerLive";

//   const ticker = showTicker ? (
//     <LiveTickers
//       messages={[userData?.tickers?.tickerSettings?.tickerText]}
//       speed={userData?.tickers?.tickerSettings?.tickerSpeed}
//       direction={
//         userData?.tickers?.tickerSettings?.tickerDirection === "rightToLeft"
//           ? "right"
//           : userData?.tickers?.tickerSettings?.tickerDirection === "leftToRight"
//             ? "left"
//             : "center"
//       }
//       position={
//         tickerPosition === "middleOfThePage"
//           ? "center"
//           : tickerPosition === "topOfThePage"
//             ? "top"
//             : "bottom"
//       }
//       tickerTextColor={userData?.tickers?.tickerSettings?.tickerTextColor}
//       tickerBgColor={userData?.tickers?.tickerSettings?.tickerBgColor}
//       checkIfTrue={false}
//       inline
//     />
//   ) : null;

//   return (
//     <>
//       {userData?.theme?.themeNavigationBar?.navBarTreatment ===
//         "alwaysVisible" &&
//         shouldRenderAgmHeader && (
//           <MenuBurger
//             {...{ actions }}
//             color={userData?.theme?.themeNavigationBar?.menuButtonTextColor}
//             hoverColor={
//               userData?.theme?.themeNavigationBar?.menuButtonHoverColor
//             }
//             menuBackgroundColor={
//               userData?.theme?.themeNavigationBar?.menuButtonBgColor
//             }
//             activeMenuButtonBgColor={
//               userData?.theme?.themeNavigationBar?.activeMenuButtonBgColor
//             }
//             activeMenuButtonTextColor={
//               userData?.theme?.themeNavigationBar?.activeMenuButtonTextColor
//             }
//           />
//         )}
//       <Center>
//         {userData?.general?.eventStatus === "inactive" &&
//         (userData?.general?.playbackInfo?.playbackRequired === false ||
//           !userData?.general?.playbackInfo?.playbackRequired) ? (
//           <OuterContainer>
//             <DrawerContainer>
//               <h2>Your event is inactive</h2>
//             </DrawerContainer>
//           </OuterContainer>
//         ) : (
//           <OuterContainer
//             checkAgm={userData?.general?.eventTemplate === "AGM" ? true : false}
//           >
//             {location.href.includes("agenda") ? (
//               shouldRenderSpeakers && (
//                 <AgendaTab speakerSettings={speakerSettings} />
//               )
//             ) : location.href.includes("speakers") ? (
//               shouldRenderSpeakers && (
//                 <SpeakersTab speakerSettings={speakerSettings} />
//               )
//             ) : location.href.includes("resources") ? (
//               shouldRenderResources && (
//                 <ResourcesTab resourceSetting={resourceSetting} />
//               )
//             ) : location.href.includes("videos") ? (
//               shouldRenderResources && (
//                 <VideosTab resourceSetting={resourceSetting} />
//               )
//             ) : location.href.includes("polling") ? (
//               <PollBarChart individualPollResponses={pollResult} />
//             ) : location.href.includes("feedback") ? (
//               <Feedback
//                 fields={fields}
//                 initialState={initialState}
//                 userData={userData}
//               />
//             ) : location.href.includes("general-guidelines-tab") ? (
//               <GeneralGuidelinesTab
//                 generalGuidelinesTab={
//                   userData?.additionaltabs?.generalGuidelinesTab
//                 }
//               />
//             ) : location.href.toLowerCase().includes("faqs") ? (
//               <FAQs data={userData?.faq || []} />
//             ) : location.href.toLowerCase().includes("help") ? (
//               <FAQs data={userData?.help || []} help={true} />
//             ) : userData?.general?.eventStatus === "inactive" &&
//               userData?.general?.playbackInfo?.playbackRequired &&
//               !userData?.general?.playbackInfo?.playbackVideo?.length ? (
//               <DrawerContainer>
//                 <h2>Playback is getting ready for this event</h2>
//               </DrawerContainer>
//             ) : userData?.general?.eventStatus === "inactive" &&
//               userData?.general?.playbackInfo?.playbackRequired &&
//               userData?.general?.playbackInfo?.playbackVideo?.length ? (
//               <VideoWrapper>
//                 {userData?.general?.playbackInfo?.playbackVideo && (
//                   <VideoPlayer
//                     src={userData?.general?.playbackInfo?.playbackVideo}
//                   />
//                 )}
//               </VideoWrapper>
//             ) : (
//               <Container
//                 headerHeight={headerHeight}
//                 // bgImage={userData?.theme?.themeGeneral?.backgroundImage}
//               >
//                 {userData?.tickers?.tickerSettings?.tickerVisibility ===
//                 "pauseTheTicker" ? (
//                   <TopTickerPauseContainer
//                     style={{
//                       color: userData?.tickers?.tickerSettings?.tickerTextColor,
//                     }}
//                   >
//                     {userData?.tickers?.tickerSettings?.tickerText}
//                   </TopTickerPauseContainer>
//                 ) : (
//                   tickerPosition === "topOfThePage" && ticker
//                 )}

//                 {userData?.livepage?.livePageSettings?.contentFormat ===
//                   "video" &&
//                   (hasLiveVideo || hasSecondaryContent) && (
//                     <StageRow
//                       key={liveStream?.streamingKey || "stage-row"}
//                       reverse={
//                         userData?.theme?.themeGeneral
//                           ?.secondaryContentLayout ===
//                         "secondaryContentLeftLiveVideoRight"
//                       }
//                       solo={isSoloStage}
//                     >
//                       {hasLiveVideo && (
//                         <VideoPane solo={hasLiveVideo && !hasSecondaryContent}>
//                           <VideoBoxWrapper>
//                             <VideoBox src={liveStream.liveStreamPlayerUrl} />
//                           </VideoBoxWrapper>
//                         </VideoPane>
//                       )}

//                       {hasSecondaryContent && (
//                         <SecondaryContentCard
//                           solo={hasSecondaryContent && !hasLiveVideo}
//                         >
//                           {secondaryContentNode}
//                         </SecondaryContentCard>
//                       )}
//                     </StageRow>
//                   )}

//                 {(userData?.livepage?.livePageSettings?.textQuestion ||
//                   userData?.livepage?.livePageSettings?.videoQuestion ||
//                   (userData?.theme?.themeGeneral?.guidelinesPopupLabelText &&
//                     userData?.theme?.themeGeneral?.guidelinesPopupContent)) && (
//                   <ActionBar solo={isSoloStage}>
//                     <ActionBarGroup>
//                       {userData?.livepage?.livePageSettings?.textQuestion ? (
//                         <PrimaryCTAButton
//                           ref={buttonRef}
//                           onClick={() => setModal({ state: true })}
//                         >
//                           {userData?.livepage?.livePageSettings
//                             ?.textQuestionLabel
//                             ? userData?.livepage?.livePageSettings
//                                 ?.textQuestionLabel
//                             : "Text Question"}
//                         </PrimaryCTAButton>
//                       ) : null}
//                       {userData?.livepage?.livePageSettings?.videoQuestion ? (
//                         <PrimaryCTAButton ref={buttonRef}>
//                           {userData?.livepage?.livePageSettings
//                             ?.videoQuestionLabel
//                             ? userData?.livepage?.livePageSettings
//                                 ?.videoQuestionLabel
//                             : "Video Question"}
//                         </PrimaryCTAButton>
//                       ) : null}
//                     </ActionBarGroup>

//                     {userData?.theme?.themeGeneral?.guidelinesPopupLabelText &&
//                       userData?.theme?.themeGeneral?.guidelinesPopupContent && (
//                         <ActionBarGroup>
//                           <PrimaryCTAButton
//                             style={{

//                               background:
//                                 userData?.theme?.themeGeneral
//                                   ?.guidelinesPopupColor,
//                               color:
//                                 userData?.theme?.themeGeneral?.labelTextColor ||
//                                 "#fff",
//                               border: `1px solid ${
//                                 userData?.theme?.themeGeneral
//                                   ?.guidelinesPopupColor
//                               }`,
//                             }}
//                             onClick={() => setGuidelinesOpen(true)}
//                           >
//                             {
//                               userData?.theme?.themeGeneral
//                                 ?.guidelinesPopupLabelText
//                             }
//                           </PrimaryCTAButton>
//                         </ActionBarGroup>
//                       )}
//                   </ActionBar>
//                 )}
//                 {tickerPosition === "bottomOfThePage" && ticker}
//                 {guidelinesOpen && (
//                   <GuidelinesDialog
//                     open={guidelinesOpen}
//                     onClose={() => setGuidelinesOpen(false)}
//                     title={
//                       userData?.theme?.themeGeneral?.guidelinesPopupLabelText ||
//                       "Guidelines"
//                     }
//                     content={
//                       userData?.theme?.themeGeneral?.guidelinesPopupContent
//                     }
//                   />
//                 )}

//                 {modal?.state && <ChatModal {...{ modal, setModal }} />}
//                 {pollModal?.state && (
//                   <Polling {...{ pollModal, setPollModal }} />
//                 )}
//               </Container>
//             )}
//           </OuterContainer>
//         )}
//       </Center>
//     </>
//   );
// };

// export default JoinEvent;

// export const OuterContainer = styled.div`
//   width: 100%;
//   min-height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding-top: ${({ checkAgm }) => (checkAgm ? "0px" : "10px")};
//   padding-bottom: 10px;
//   box-sizing: border-box;

//   @media ${theme.breakpoints.sm_up} {
//     min-height: 90vh;
//   }
// `;

// export const Container = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin: 0 auto;
//   margin-top: 25px;

//   min-height: calc(
//     100vh - var(--agm-header-height, ${({ headerHeight }) => headerHeight}px)
//   );

//   @media (max-width: 600px) {
//     padding-top: 8px;
//     padding-left: 12px;
//     padding-right: 12px;
//   }
// `;

// const StageRow = styled.div`
//   width: 100%;
//   margin: 12px auto 0;
//   display: flex;
//   flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
//   align-items: stretch;
//   justify-content: ${({ solo }) => (solo ? "center" : "flex-start")};
//   gap: 24px;

//   @media (max-width: 900px) {
//     flex-direction: column;
//     gap: 16px;
//     margin-top: 10px;
//   }
// `;

// const VideoPane = styled.div`
//   position: relative;
//   flex: ${({ solo }) => (solo ? "0 1 auto" : "1 1 0")};
//   width: ${({ solo }) => (solo ? "100%" : "auto")};
//   max-width: ${({ solo }) => (solo ? "900px" : "none")};
//   min-width: 0;
//   aspect-ratio: 16 / 9;
//   max-height: 65vh;
//   margin: ${({ solo }) => (solo ? "0 auto" : "0")};
//   display: flex;
//   border-radius: 8px;
//   overflow: hidden;
//   background: #000;

//   @media (max-width: 900px) {
//     flex: 1 1 100%;
//     max-width: 100%;
//     max-height: 50vh;
//   }

//   @media (max-width: 600px) {
//     max-height: 40vh;
//     border-radius: 4px;
//   }
// `;

// const SecondaryContentCard = styled.div`
//   flex: ${({ solo }) => (solo ? "0 1 auto" : "1 1 0")};
//   width: ${({ solo }) => (solo ? "100%" : "auto")};
//   max-width: ${({ solo }) => (solo ? "900px" : "none")};
//   min-width: 0;
//   margin: ${({ solo }) => (solo ? "0 auto" : "0")};
//   aspect-ratio: ${({ solo }) => (solo ? "16 / 9" : "auto")};
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   border-radius: 8px;
//   overflow: hidden;
//   background: #fff;
//   box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);

//   iframe,
//   img,
//   video {
//     width: 100%;
//     height: 100%;
//     border: 0;
//     object-fit: contain;
//   }

//   @media (max-width: 900px) {
//     flex: 1 1 100%;
//     max-width: 100%;
//     aspect-ratio: 16 / 9;
//   }
// `;

// const VideoWrapper = styled.div`
//   width: 70%;
//   margin: 2% 14%;
//   padding: 4%;
//   border-radius: 5px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   overflow: hidden;

//   @media (max-width: 600px) {
//     width: 92%;
//     margin: 4% 4%;
//   }
// `;

// export const AboutUsBody = styled.section`
//   background-color: #f9f9f9;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   @media (max-width: 600px) {
//     height: unset;
//   }
// `;
// export const GreySection = styled.section`
//   display: flex;
//   flex-direction: column;
//   padding: 60px 0 60px 0;
//   align-items: center;
//   background-color: #f9f9f9;
//   width: 100vw;
// `;
// export const WhiteSection = styled.section`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   width: 100vw;
// `;

// export const H2 = styled.h2`
//   font-family: ${theme.fonts.primaryFontBold};
//   color: ${COLORS.COLOR_DARK};
//   font-size: 22px;
//   margin-bottom: 32px;
//   cursor: default;
//   padding: 0 20px;
//   margin: 0 auto;
//   @media (max-width: 1024px) {
//     font-size: 24px;
//     text-align: center;
//   }
// `;

// export const BodyWrap = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex-wrap: wrap;
//   align-items: center;
//   justify-content: center;
//   font-size: 18px;
//   padding: 1%;
//   color: ${COLORS.BTN_GREEN};
//   font-family: ${theme.fonts.primaryFontBold};
//   width: 100%;
//   @media (max-width: 700px) {
//     flex-direction: column;
//   }
// `;

// export const Loader = styled.div`
//   align-items: center;
//   justify-content: center;
// `;

// const Center = styled.div`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   padding: 0px 20px;
//   box-sizing: border-box;

//   @media only screen and (max-width: 767px) {
//     padding: 0 12px;
//   }
// `;

// const ActionBar = styled.div`
//   width: 100%;
//   max-width: ${({ solo }) => (solo ? "900px" : "100%")};
//   margin: 20px auto 0;
//   display: flex;
//   flex-wrap: wrap;
//   align-items: center;
//   justify-content: space-between;
//   gap: 12px;

//   @media (max-width: 600px) {
//     justify-content: center;
//     margin-top: 16px;
//   }
// `;

// const ActionBarGroup = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   align-items: center;
//   gap: 10px;

//   & > button {
//     height: 46px;
//     padding: 0 18px;
//     white-space: nowrap;
//   }

//   @media (max-width: 600px) {
//     justify-content: center;
//     width: 100%;
//   }
// `;
// export const TopTickerPauseContainer = styled.div`
//   position: relative;
//   width: 100%;
//   font-size: 18px;
//   padding: 8px 0;
//   opacity: 0.9;
//   text-align: center;
//   overflow: hidden;
//   pointer-events: none;
//   z-index: 1;
// `;

// const VideoBoxWrapper = styled.div`
//   width: 100%;
//   height: 100%;

//   & > * {
//     width: 100% !important;
//     height: 100% !important;
//   }

//   video,
//   iframe {
//     width: 100% !important;
//     height: 100% !important;
//     object-fit: contain;
//   }
// `;

import React, { useState, useRef, useEffect, useCallback } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { PrimaryCTAButton } from "../../common/Buttons";
import ChatModal from "./ChatModal";
import COLORS from "../../../assets/Colors";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import "./Timeline.css";
import EventService from "../../../services/EventService";
import useViewer from "../../../hooks/useViewer";
import LiveTickers from "../Liveresources/Tickers";
import Feedback from "../Liveresources/Feedback";
import VideoBox from "../../common/VideoBox";
import MenuBurger from "../../common/ActionBar/MenuBurger";
import { navigate, useLocation } from "@reach/router";
import Polling from "../../common/Polling";
import AgendaTab from "../MenuBar/Agenda";
import SpeakersTab from "../MenuBar/Speakers";
import ResourcesTab from "../MenuBar/Resources";
import VideosTab from "../MenuBar/Videos";
import HostService from "../../../services/HostService";
import useLoader from "../../../hooks/useLoader";
import PollBarChart from "../MenuBar/PollBarChart";
import GeneralGuidelinesTab from "../MenuBar/GeneralGuidelines";
import { DrawerContainer } from "../Register";
import VideoPlayer from "../../common/Video";
import FAQs from "../MenuBar/Faqs";
import GuidelinesDialog from "./GuidelinesDialog";

const POLL_INTERVAL_MS = 2000;

const JoinEvent = () => {
  const buttonRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const { userObject, setGlobalState } = useViewer();
  const [modal, setModal] = useState({ state: false });
  const [userData, setUserData] = useState();
  const location = useLocation();
  const [pollModal, setPollModal] = useState({ state: false });
  const { setLoader } = useLoader();
  const [fields, setFields] = useState({});
  const [initialState, setInitialState] = useState();
  const [pollResult, setPollResult] = useState([]);
  const [guidelinesOpen, setGuidelinesOpen] = useState(false);

  const fetchEventInfo = useCallback(
    async ({ showLoader = false } = {}) => {
      try {
        if (showLoader) {
          setLoader({ state: true, message: "Fetching live..." });
        }

        const response = await EventService.eventInfoEventViewerLive(
          userObject?.eventId,
          "live",
        );

        setUserData(response);
        setGlobalState(response);
        setFields(response?.feedback?.feedbackForm);

        if (response?.feedback?.feedbackForm !== null) {
          if (
            Object.keys(response?.feedback?.feedbackForm || {}).length !== 0
          ) {
            setInitialState(
              Object.keys(response.feedback.feedbackForm).reduce((acc, key) => {
                const firstFieldType =
                  response.feedback.feedbackForm[key][0]?.type;
                acc[key] =
                  firstFieldType === "checkbox"
                    ? []
                    : firstFieldType === "radio" || firstFieldType === "select"
                      ? ""
                      : "";
                return acc;
              }, {}),
            );
          }
        }

        if (
          response?.polling?.pollQuestions?.filter((arr) => arr.pollResult)
            .length
        ) {
          const res = await HostService.getPollingResults(userObject?.eventId);
          setPollResult(res?.IndividualPollResponses);
        }

        if (response?.livepage?.livePageSettings?.livePoll) {
          const liveQuestions = response?.polling?.pollQuestions?.filter(
            (item) => item?.accept === "pollsAreLive",
          );
          const votedArray = localStorage.getItem("pollArray") || "";
          const unvoted = liveQuestions?.filter(
            (arr) => !votedArray.includes(arr.question),
          );

          if (liveQuestions?.length && unvoted?.length) {
            setPollModal({
              state: true,
              eventId: userObject?.eventId,
              viewerId: userObject?.id,
              userData: unvoted,
            });
          } else {
            setPollModal({ state: false });
          }
        }
      } catch (err) {
        const message = getErrorMessage(err);
        if (showLoader) {
          enqueueSnackbar(message, { variant: "error" });
        }
        if (err.errorCode === "ER-UNAUTHORISED-USER") {
          navigate(location.pathname);
        }
      } finally {
        if (showLoader) {
          setLoader({ state: false });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userObject?.eventId, userObject?.id],
  );

  // Initial load (shows the loader) + recurring poll (silent, no loader)
  useEffect(() => {
    if (!userObject?.eventId) return;

    fetchEventInfo({ showLoader: true });

    const interval = setInterval(() => {
      fetchEventInfo({ showLoader: false });
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [userObject?.eventId, fetchEventInfo]);

  const actions = [
    { text: "Home", props: { onClick: () => navigate(`/live#home`) } },
    {
      text: "Agenda",
      props: { onClick: () => navigate("#agenda") },
      hidden:
        userData?.event?.speakerSection?.speakersRequired &&
        userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Speakers",
      props: { onClick: () => navigate("#speakers") },
      hidden:
        userData?.event?.speakerSection?.speakersRequired &&
        userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Resources",
      props: { onClick: () => navigate("#resources") },
      hidden:
        userData?.event?.resourceSection?.resourcesRequired &&
        userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Videos",
      props: { onClick: () => navigate("#videos") },
      hidden:
        userData?.event?.resourceSection?.resourcesRequired &&
        userData?.event?.eventSettings?.userViewInsidePage
          ? false
          : true,
    },
    {
      text: "Polling",
      props: { onClick: () => navigate("#polling") },
      hidden: userData?.livepage?.livePageSettings?.livePoll ? false : true,
    },
    {
      text:
        userData?.livepage?.livePageSettings?.generalGuidelinesLabel ||
        "General Guidelines Tab",
      props: { onClick: () => navigate("#general-guidelines-tab") },
      hidden: userData?.livepage?.livePageSettings?.generalGuidelines
        ? false
        : true,
    },
    { text: "FAQs", props: { onClick: () => navigate("#faqs") } },
    { text: "Help", props: { onClick: () => navigate("#help") } },
    {
      text: "Feedback",
      props: { onClick: () => navigate("#feedback") },
      hidden:
        userData?.feedback?.feedbackForm &&
        Object.keys(userData.feedback.feedbackForm).length !== 0
          ? false
          : true,
    },
  ];

  const { resourceSection, resourceSetting, speakerSection, speakerSettings } =
    userData || {};
  const { resourcesRequired, resourcesVisibility } = resourceSection || {};
  const { speakersRequired, speakersVisibility } = speakerSection || {};
  const { galleryView } = userData?.livepage || {};

  const shouldRenderResources =
    resourcesRequired &&
    (resourcesVisibility === "afterLogin" ||
      resourcesVisibility === "bothBeforeAfter");

  const shouldRenderSpeakers =
    speakersRequired &&
    (speakersVisibility === "afterLogin" ||
      speakersVisibility === "bothBeforeAfter");

  const shouldRenderAgmHeader =
    userData?.general?.eventTemplate === "AGM" && galleryView?.showHeader
      ? true
      : userData?.general?.eventTemplate !== "AGM"
        ? true
        : userData?.general?.eventTemplate === "AGM" && !galleryView?.showHeader
          ? false
          : true;

  const renderSecondaryContent = () => {
    const media = userData?.theme?.themeGeneral?.secondaryContentMedia;
    if (!media) return null;

    const extension = media.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(extension)) {
      return (
        <img
          src={media}
          alt="Secondary Content"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      );
    }

    if (extension === "pdf") {
      return (
        <iframe
          src={media}
          title="Secondary Content"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      );
    }

    if (["mp4", "webm", "ogg"].includes(extension)) {
      return (
        <video src={media} controls style={{ width: "100%", height: "100%" }} />
      );
    }

    return null;
  };

  const liveStream = userData?.livepage?.liveStreamSettings?.find(
    (item) => item.label === "Live Stream",
  );
  const secondaryContentNode = renderSecondaryContent();
  const hasLiveVideo = !!liveStream?.liveStreamPlayerUrl;
  const hasSecondaryContent = !!secondaryContentNode;
  const isSoloStage =
    (hasLiveVideo && !hasSecondaryContent) ||
    (hasSecondaryContent && !hasLiveVideo);
  const hasNoStageContent = !hasLiveVideo && !hasSecondaryContent;

  const tickerPosition = userData?.tickers?.tickerSettings?.tickerPosition;

  const showTicker =
    userData?.livepage?.livePageSettings?.liveTickers &&
    userData?.tickers?.tickerSettings?.tickerVisibility === "tickerLive";

  const hasBottomTicker =
    showTicker && tickerPosition === "bottomOfThePage";

  const ticker = showTicker ? (
    <LiveTickers
      messages={[userData?.tickers?.tickerSettings?.tickerText]}
      speed={userData?.tickers?.tickerSettings?.tickerSpeed}
      direction={
        userData?.tickers?.tickerSettings?.tickerDirection === "rightToLeft"
          ? "right"
          : userData?.tickers?.tickerSettings?.tickerDirection === "leftToRight"
            ? "left"
            : "center"
      }
      position={
        tickerPosition === "middleOfThePage"
          ? "center"
          : tickerPosition === "topOfThePage"
            ? "top"
            : "bottom"
      }
      tickerTextColor={userData?.tickers?.tickerSettings?.tickerTextColor}
      tickerBgColor={userData?.tickers?.tickerSettings?.tickerBgColor}
      checkIfTrue={false}
      inline
      viewportEdge={hasBottomTicker}
    />
  ) : null;

  const hasQuestionButtons =
    userData?.livepage?.livePageSettings?.textQuestion ||
    userData?.livepage?.livePageSettings?.videoQuestion;

  const hasGuidelinesButton =
    userData?.theme?.themeGeneral?.guidelinesPopupLabelText &&
    userData?.theme?.themeGeneral?.guidelinesPopupContent;

  // Text Question + Video Question live in the SAME flex row now, so
  // if both are enabled they split the column 50/50; if only one is
  // enabled it stretches to fill the full column width.
    const questionButtons = hasQuestionButtons && (
    <>
      {userData?.livepage?.livePageSettings?.textQuestion ? (
        <PrimaryCTAButton
          ref={buttonRef}
          onClick={() => setModal({ state: true })}
          style={{
            backgroundColor:
              userData?.theme?.themeGeneral?.askQuestionButtonColor,
            color: userData?.theme?.themeGeneral?.askQuestionTextColor || "#fff",
            border: "none",
            fontSize: "16px",
          }}
        >
          {userData?.livepage?.livePageSettings?.textQuestionLabel ||
            "Text Question"}
        </PrimaryCTAButton>
      ) : null}
    </>
  );

const guidelinesButton = hasGuidelinesButton && (
  <PrimaryCTAButton
   style={{
      backgroundColor:
        userData?.theme?.themeGeneral?.guidelinesPopupButtonBackgroundColor,
      color:
        userData?.theme?.themeGeneral?.guidelinesPopupButtonTextColor || "#fff",
      border: `1px solid ${
        userData?.theme?.themeGeneral?.guidelinesPopupButtonBackgroundColor
        }`,
      border: "none",
      fontSize: "16px",
    }}
    onClick={() => setGuidelinesOpen(true)}
  >
    {userData?.theme?.themeGeneral?.guidelinesPopupLabelText}
  </PrimaryCTAButton>
);

  return (
    <>
      {userData?.theme?.themeNavigationBar?.navBarTreatment ===
        "alwaysVisible" &&
        shouldRenderAgmHeader && (
          <MenuBurger
            {...{ actions }}
            color={userData?.theme?.themeNavigationBar?.menuButtonTextColor}
            hoverColor={
              userData?.theme?.themeNavigationBar?.menuButtonHoverColor
            }
            menuBackgroundColor={
              userData?.theme?.themeNavigationBar?.menuButtonBgColor
            }
            activeMenuButtonBgColor={
              userData?.theme?.themeNavigationBar?.activeMenuButtonBgColor
            }
            activeMenuButtonTextColor={
              userData?.theme?.themeNavigationBar?.activeMenuButtonTextColor
            }
          />
        )}
      <Center>
        {userData?.general?.eventStatus === "inactive" &&
        (userData?.general?.playbackInfo?.playbackRequired === false ||
          !userData?.general?.playbackInfo?.playbackRequired) ? (
          <OuterContainer>
            <DrawerContainer>
              <h2>Your event is inactive</h2>
            </DrawerContainer>
          </OuterContainer>
        ) : (
          <OuterContainer>
            {location.href.includes("agenda") ? (
              shouldRenderSpeakers && (
                <AgendaTab speakerSettings={speakerSettings} />
              )
            ) : location.href.includes("speakers") ? (
              shouldRenderSpeakers && (
                <SpeakersTab speakerSettings={speakerSettings} />
              )
            ) : location.href.includes("resources") ? (
              shouldRenderResources && (
                <ResourcesTab resourceSetting={resourceSetting} />
              )
            ) : location.href.includes("videos") ? (
              shouldRenderResources && (
                <VideosTab resourceSetting={resourceSetting} />
              )
            ) : location.href.includes("polling") ? (
              <PollBarChart individualPollResponses={pollResult} />
            ) : location.href.includes("feedback") ? (
              <Feedback
                fields={fields}
                initialState={initialState}
                userData={userData}
              />
            ) : location.href.includes("general-guidelines-tab") ? (
              <GeneralGuidelinesTab
                generalGuidelinesTab={
                  userData?.additionaltabs?.generalGuidelinesTab
                }
              />
            ) : location.href.toLowerCase().includes("faqs") ? (
              <FAQs data={userData?.faq || []} />
            ) : location.href.toLowerCase().includes("help") ? (
              <FAQs data={userData?.help || []} help={true} />
            ) : userData?.general?.eventStatus === "inactive" &&
              userData?.general?.playbackInfo?.playbackRequired &&
              !userData?.general?.playbackInfo?.playbackVideo?.length ? (
              <DrawerContainer>
                <h2>Playback is getting ready for this event</h2>
              </DrawerContainer>
            ) : userData?.general?.eventStatus === "inactive" &&
              userData?.general?.playbackInfo?.playbackRequired &&
              userData?.general?.playbackInfo?.playbackVideo?.length ? (
              <VideoWrapper>
                {userData?.general?.playbackInfo?.playbackVideo && (
                  <VideoPlayer
                    src={userData?.general?.playbackInfo?.playbackVideo}
                  />
                )}
              </VideoWrapper>
            ) : (
              <Container hasBottomTicker={hasBottomTicker}>
                {userData?.tickers?.tickerSettings?.tickerVisibility ===
                "pauseTheTicker" && userData?.livepage?.livePageSettings?.liveTickers ? (
                  <TopTickerPauseContainer
                    style={{
                      color: userData?.tickers?.tickerSettings?.tickerTextColor,
                      backgroundColor: userData?.tickers?.tickerSettings?.tickerBgColor,
                    }}
                  >
                    {userData?.tickers?.tickerSettings?.tickerText}
                  </TopTickerPauseContainer>
                ) : (
                  tickerPosition === "topOfThePage" && ticker
                )}

                {userData?.livepage?.livePageSettings?.contentFormat ===
                  "video" &&
                  !hasNoStageContent && (
                    <StageRow
                      key={liveStream?.streamingKey || "stage-row"}
                      reverse={
                        userData?.theme?.themeGeneral
                          ?.secondaryContentLayout ===
                        "secondaryContentLeftLiveVideoRight"
                      }
                      solo={isSoloStage}
                    >
                      {hasLiveVideo && (
                        <StageColumn
                          solo={hasLiveVideo && !hasSecondaryContent}
                        >
                          <VideoPane>
                            <VideoBoxWrapper>
                              <VideoBox src={liveStream.liveStreamPlayerUrl} />
                            </VideoBoxWrapper>
                          </VideoPane>

                          {hasQuestionButtons && (
                            <ColumnActionBar>{questionButtons}</ColumnActionBar>
                          )}
                        </StageColumn>
                      )}

                      {hasSecondaryContent && (
                        <StageColumn
                          solo={hasSecondaryContent && !hasLiveVideo}
                        >
                          <SecondaryContentCard>
                            {secondaryContentNode}
                          </SecondaryContentCard>

                          {hasGuidelinesButton && (
                            <ColumnActionBar>
                              {guidelinesButton}
                            </ColumnActionBar>
                          )}
                        </StageColumn>
                      )}
                    </StageRow>
                  )}

                {tickerPosition === "middleOfThePage" && ticker}

                {hasNoStageContent &&
                  (hasQuestionButtons || hasGuidelinesButton) && (
                    <ActionBar solo>
                      {hasQuestionButtons && (
                        <ActionBarGroup>{questionButtons}</ActionBarGroup>
                      )}
                      {hasGuidelinesButton && (
                        <ActionBarGroup>{guidelinesButton}</ActionBarGroup>
                      )}
                    </ActionBar>
                  )}

                {tickerPosition === "bottomOfThePage" && ticker}

                {guidelinesOpen && (
                  <GuidelinesDialog
                  open={guidelinesOpen}
                  onClose={() => setGuidelinesOpen(false)}
                  title={userData?.theme?.themeGeneral?.guidelinesPopupLabelText}
                  content={userData?.theme?.themeGeneral?.guidelinesPopupContent}
                  buttonText="Got it, Thanks"
                  buttonBackgroundColor={
                    userData?.theme?.themeGeneral?.guidelinesPopupButtonBackgroundColor
                  }
                  buttonTextColor={
                    userData?.theme?.themeGeneral?.guidelinesPopupButtonTextColor
                  }
                />
                )}
              {modal?.state && (
                <ChatModal
                  modal={modal}
                  setModal={setModal}
                  askQuestionButtonColor={
                    userData?.theme?.themeGeneral?.askQuestionButtonColor
                  }
                  askQuestionTextColor={
                    userData?.theme?.themeGeneral?.askQuestionTextColor || "#fff"
                  }
                />
              )}
                {pollModal?.state && (
                  <Polling {...{ pollModal, setPollModal }} />
                )}
              </Container>
            )}
          </OuterContainer>
        )}
      </Center>
    </>
  );
};

export default JoinEvent;

export const OuterContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  margin: 0 auto;
  padding: clamp(12px, 2vh, 24px) clamp(12px, 2vw, 28px)
    ${({ hasBottomTicker }) =>
      hasBottomTicker ? "clamp(58px, 8vh, 72px)" : "clamp(12px, 2vh, 24px)"};
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;

  @media (max-width: 900px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: 600px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

const StageRow = styled.div`
  width: 100%;
  // max-width: 1440px;
  flex: 1 0 auto;
  min-height: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  align-items: flex-start; //center;
  justify-content: center;
  gap: clamp(12px, 2vw, 28px);

  @media (max-width: 900px) {
    flex-direction: column;
    flex: 0 0 auto;
    gap: 16px;
  }
`;

const StageColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: ${({ solo }) => (solo ? "0 1 900px" : "1 1 0")};
  width: ${({ solo }) => (solo ? "100%" : "auto")};
  max-width: ${({ solo }) => (solo ? "900px" : "none")};
  min-width: 0;
  margin: ${({ solo }) => (solo ? "0 auto" : "0")};

  @media (max-width: 900px) {
    flex: 1 1 100%;
    max-width: 100%;
    width: 100%;
  }
`;

const StagePaneBase = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: min(62vh, 720px);
  display: flex;
  //border-radius: 8px;
  overflow: hidden;

  @media (max-width: 900px) {
    max-height: none;
  }

  @media (max-width: 600px) {
    border-radius: 4px;
  }
`;

const VideoPane = styled(StagePaneBase)`
  background: #000;
`;

const SecondaryContentCard = styled(StagePaneBase)`
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);

  iframe,
  img,
  video {
    width: 100%;
    height: 100%;
    border: 0;
    object-fit: contain;
  }
`;

const VideoWrapper = styled.div`
  width: 70%;
  margin: 2% 14%;
  padding: 4%;
  //border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 900px) {
    width: 85%;
    margin: 3% 7.5%;
  }

  @media (max-width: 600px) {
    width: 92%;
    margin: 4% 4%;
    padding: 3%;
  }
`;

export const AboutUsBody = styled.section`
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    height: unset;
  }
`;

export const GreySection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 60px 0;
  align-items: center;
  background-color: #f9f9f9;
  width: 100vw;

  @media (max-width: 600px) {
    padding: 32px 0;
  }
`;

export const WhiteSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
`;

export const H2 = styled.h2`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 22px;
  margin-bottom: 32px;
  cursor: default;
  padding: 0 20px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    font-size: 24px;
    text-align: center;
  }

  @media (max-width: 600px) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

export const BodyWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 1%;
  color: ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontBold};
  width: 100%;

  @media (max-width: 700px) {
    flex-direction: column;
    font-size: 15px;
  }
`;

export const Loader = styled.div`
  align-items: center;
  justify-content: center;
`;

const Center = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
`;

const ColumnActionBar = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 12px;
  //width: min(100%, 520px);
  width: auto;
  & > button {
    flex: 1 1 0;
    min-width: 0;
    height: 44px;
    padding: 0 18px;
  }

  @media (max-width: 600px) {
    & > button {
      height: 40px;
      padding: 0 14px;
      font-size: 13px;
    }
  }
`;

const ActionBar = styled.div`
  width: 100%;
  max-width: ${({ solo }) => (solo ? "900px" : "100%")};
  margin: 20px auto 0;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 12px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const ActionBarGroup = styled.div`
  display: flex;
  flex: 1 1 0;
  gap: 10px;
  
  & > button {
    flex: 1 1 0;
    min-width: 0;
    height: 46px;
    padding: 0 18px;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const TopTickerPauseContainer = styled.div`
  position: relative;
  width: 100%;
  //max-width: 1440px;
  flex: 0 0 auto;
  font-size: 18px;
  margin-bottom: clamp(12px, 2vh, 20px);
  padding: 8px 1px;
  box-sizing: border-box;
  opacity: 0.9;
  text-align: center;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const VideoBoxWrapper = styled.div`
  width: 100%;
  height: 100%;

  & > * {
    width: 100% !important;
    height: 100% !important;
  }

  video,
  iframe {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }
`;
